import DetailCardBody from '@/common/components/DetailCard/DetailCardBody';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard';
import FileHeader from '@/common/components/DetailCard/headers/fileHeader/FileHeader';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import LoadingPage from '@/common/pages/LoadingPage';
import { fileInformationQueryOptions } from '@/modules/FileDetail/queries/fileInformation/fileInformationQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal open={open} closeModal={closeModal}>
    <FileInformationModal />
  </MainModal>
);

const FileInformationModal = () => {
  const { id } = useParams();

  const { data, isPending, isError } = useQuery(
    fileInformationQueryOptions(id!),
  );
  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }

  return (
    <>
      <TitleDescription textStyle="h2" color="black-1">
        مشخصات پرونده
      </TitleDescription>
      <Box py="24px">
        <MainDetailCard>
          <FileHeader fileType={data.file_type?.const!} />
          <DetailCardBody>
            <DetailCardItems
              backgroundColor="pink-1"
              items={data?.detailCardItems ?? []}
            />
          </DetailCardBody>
        </MainDetailCard>
      </Box>
    </>
  );
};
